import { LOCALES } from 'i18n/locales';

export const AOIMarkUpSnackBarIntl = {
    [LOCALES.ENGLISH]: {
        'mobileMarkUp.alert': 'A 50 metre area will appear on the centre of the map at the required zoom level to display assets. Once the area outline has appeared, tap the \'Draw area\' button to populate the area with the assets at that location. If no area appears, continue to zoom in to the required zoom level.',
        'mobileMarkUp.notification.label': 'Mobile markup'
    },
    [LOCALES.WELSH]: {
        'mobileMarkUp.alert': 'Bydd ardal 50 metr yn ymddangos yng nghanol y map ar y lefel chwyddo sy’n ofynnol i ddangos asedau. Pan fydd amlinelliad o’r ardal wedi ymddangos, tapiwch y botwm ‘Lluniadu ardal’ i ychwanegu’r asedau at yr ardal yn y lleoliad hwnnw. Os na fydd ardal yn ymddangos, chwyddwch i mewn i’r lefel chwyddo sy’n ofynnol.',
        'mobileMarkUp.notification.label': 'Marcio i fyny symudol'
    }
};
